module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cFIIJ"))).then(() => parcelRequire('d0iPb'));